import {SplitText} from "gsap/SplitText";
import {gsap} from "gsap";
import {ScrollTrigger} from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger, SplitText);
const isMobileFirstLoad = window.innerWidth < 768;
window.addEventListener('load', () => {

if (!isMobileFirstLoad) {

const titleDelivery = new SplitText(
    '.mksun-block-delivery .timeline-text-reveal:not(.timeline-text-reveal--lines)',
    {
        type: 'words'
    }
);

const linesDelivery = new SplitText('.mksun-block-delivery .timeline-text-reveal--lines', {
    type: 'lines',
    linesClass: 'line'
});

const tlDelivery = gsap.timeline({
    scrollTrigger: {
        trigger: '.mksun-block-delivery'
    }
});

tlDelivery.from(titleDelivery.words, {
    y: '100%',
    opacity: 0,
    duration: 0.5,
    ease: 'power1.out',
    stagger: 0.1
});

tlDelivery.from(
    linesDelivery.lines,
    {
        y: '100%',
        opacity: 0,
        duration: 0.5,
        ease: 'power1.out',
        stagger: 0.1
    },
    '<'
);

tlDelivery.from(
    '.mksun-block-delivery .mksun-block-delivery__img',
    {
        x: '2rem',
        opacity: 0,
        duration: 0.5,
        ease: 'power1.out'
    },
    '<'
);
}});